import { Component, OnInit } from '@angular/core';
import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import {lang_certificar} from 'app/idiomas/i18n/encuestador35/encuestador35.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { Subject } from 'rxjs';
//import { Colaboradores35Service } from 'app/main/wizard-n35/services/colaboradores35.service';
import * as backInter from 'app/auth/auth-data.model';
import * as colabInter from './timeline.interface';
import { IdiomasServiceN35 } from 'app/main/wizard-n35/services/idiomas.service';
import { ColaboradoresEncuestadorService } from 'app/main/wizard-n35encuestador/services/colaboradoresEncuestador.service';
@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent implements OnInit {
  porcentaje: number = 0;
  productoCertificar: backInter.prodNorma35;
  fechaCertificar: any;
  info:any;
  ArraySecciones: Array<any> = [];
  ArrayNum: Array<any> = [];
  data:any;
  arrayTodoList: any;
  ArrayPath: Array<any> = [];

  cantidadTareas: number = 0;
  tareasFinalizadas:number =0;
  private _unsubscribeAll: Subject<any>;
  constructor(
    private translateSrv: TranslateService,
    private colaboradoresService: ColaboradoresEncuestadorService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private idiomasService: IdiomasServiceN35

  ) {
    this._unsubscribeAll = new Subject();
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
   }

  ngOnInit() {
    this.obtieneCertificarActual();
  }

  etapa1 = [
    {
      requisito: "5.1",
      actividad: "TIMELINE.ETAPA1.SECCION1.actividad",
      entregable: "TIMELINE.ETAPA1.SECCION1.entregable",
    },
    {
      requisito: "5.2",
      actividad: "TIMELINE.ETAPA1.SECCION2.actividad",
      entregable: "TIMELINE.ETAPA1.SECCION2.entregable",

    },
    {
      requisito: "5.3",
      actividad  : "TIMELINE.ETAPA1.SECCION3.actividad",
      entregable: "TIMELINE.ETAPA1.SECCION3.entregable",

    },
    {
      requisito: "5.4",
      actividad  : "TIMELINE.ETAPA1.SECCION4.actividad",
      entregable: "TIMELINE.ETAPA1.SECCION4.entregable"

    },{
      requisito: "5.7",
      actividad  : "TIMELINE.ETAPA1.SECCION5.actividad",
      entregable: "TIMELINE.ETAPA1.SECCION5.entregable"

    },{
      requisito: "5.8",
      actividad  : "TIMELINE.ETAPA1.SECCION6.actividad",
      entregable: "TIMELINE.ETAPA1.SECCION6.entregable",

    },{
      requisito: "7.2",
      actividad  : "TIMELINE.ETAPA1.SECCION7.actividad",
      entregable: "TIMELINE.ETAPA1.SECCION7.entregable",

    },{
      requisito: "7.2 b",
      actividad  : "TIMELINE.ETAPA1.SECCION8.actividad",
      entregable: "TIMELINE.ETAPA1.SECCION8.entregable",

    },{
      requisito: "7.2 d",
      actividad  : "TIMELINE.ETAPA1.SECCION9.actividad",
      entregable: "TIMELINE.ETAPA1.SECCION9.entregable",

    },{
      requisito: "7.2 g",
      actividad : "TIMELINE.ETAPA1.SECCION10.actividad",
      entregable: "TIMELINE.ETAPA1.SECCION10.entregable",

    },{
      requisito: "7.3",
      actividad : "TIMELINE.ETAPA1.SECCION11.actividad",
      entregable: "TIMELINE.ETAPA1.SECCION11.entregable",

    },{
      requisito: "7.3 a",
      actividad  : "TIMELINE.ETAPA1.SECCION12.actividad",
      entregable: "TIMELINE.ETAPA1.SECCION12.entregable",

    },{
      requisito: "7.3 c",
      actividad  : "TIMELINE.ETAPA1.SECCION13.actividad",
      entregable: "TIMELINE.ETAPA1.SECCION13.entregable",

    },{
      requisito: "7.3 e",
      actividad  : "TIMELINE.ETAPA1.SECCION14.actividad",
      entregable: "TIMELINE.ETAPA1.SECCION14.entregable",

    },{
      requisito: "7.6",
      actividad  : "TIMELINE.ETAPA1.SECCION15.actividad",
      entregable: "TIMELINE.ETAPA1.SECCION15.entregable",

    },{
      requisito: "7.9",
      actividad  : "TIMELINE.ETAPA1.SECCION16.actividad",
      entregable: "TIMELINE.ETAPA1.SECCION16.entregable",

    },{
      requisito: "8.1 a",
      actividad  : "TIMELINE.ETAPA1.SECCION17.actividad",
      entregable: "TIMELINE.ETAPA1.SECCION17.entregable",

    },{
      requisito: "8.1 b",
      actividad  : "TIMELINE.ETAPA1.SECCION18.actividad",
      entregable: "TIMELINE.ETAPA1.SECCION18.entregable",
    },{
      requisito: "8.2",
      actividad  : "TIMELINE.ETAPA1.SECCION19.actividad",
      entregable: "TIMELINE.ETAPA1.SECCION19.entregable"
    }


  ]

  etapa2 = [
    {
      requisito: "5.5",
      actividad: "TIMELINE.ETAPA2.SECCION1.actividad",
      entregable: "Flujo de proceso.",

    },
    {
      requisito: "5.6",
      actividad  : "TIMELINE.ETAPA2.SECCION2.actividad",
      entregable: "Flujo de proceso.",

    },
    {
      requisito: "5.7 e",
      actividad  : "TIMELINE.ETAPA2.SECCION3.actividad",
      entregable: "Flujo de proceso.",

    },
    {
      requisito: "7.1",
      actividad  : "TIMELINE.ETAPA2.SECCION4.actividad",
      entregable: "Flujo de proceso.",

    },{
      requisito: "7.2 c",
      actividad  : "TIMELINE.ETAPA2.SECCION5.actividad",
      entregable: "Plan de capacitación anual, flujo de proceso de acciones correctivas.",

    },{
      requisito: "7.2. e",
      actividad  : "TIMELINE.ETAPA2.SECCION6.actividad",
      entregable: "Política.",

    },{
      requisito: "7.2. f",
      actividad  : "TIMELINE.ETAPA2.SECCION7.actividad",
      entregable: "Política.",

    },{
      requisito: "7.3 b",
      actividad  : "TIMELINE.ETAPA2.SECCION8.actividad",
      entregable: "Plan de capacitación anual.",

    },{
      requisito: "7.3 d",
      actividad  : "TIMELINE.ETAPA2.SECCION9.actividad",
      entregable: "Política.",

    },{
      requisito: "7.3 f",
      actividad  : "TIMELINE.ETAPA2.SECCION10.actividad",
      entregable: "Política y mecanismos de reconocimiento.",

    },{
      requisito: "7.4",
      actividad  : "TIMELINE.ETAPA2.SECCION11.actividad",
      entregable: "Flujo de proceso.",

    },{
      requisito: "7.5",
      actividad  : "TIMELINE.ETAPA2.SECCION12.actividad",
      entregable: "N/A.",

    },{
      requisito: "7.3 c",
      actividad  : "TIMELINE.ETAPA2.SECCION13.actividad",
      entregable: "Perfil de puesto.",

    },{
      requisito: "7.3 e",
      actividad  : "TIMELINE.ETAPA2.SECCION14.actividad",
      entregable: "Perfil de puesto.",

    },{
      requisito: "7.7",
      actividad  : "TIMELINE.ETAPA2.SECCION15.actividad",
      entregable: "Reporte.",

    },{
      requisito: "7.8",
      actividad  : "TIMELINE.ETAPA2.SECCION16.actividad",
      entregable: "Flujo de proceso y política.",

    },{
      requisito: "8.1 c",
      actividad  : "TIMELINE.ETAPA2.SECCION17.actividad",
      entregable: "Plan de desarrollo organizacional.",

    },{
      requisito: "8.1 b",
      actividad  : "TIMELINE.ETAPA2.SECCION18.actividad",
      entregable: "Flujo de proceso, reporte de DNC.",
    },{
      requisito: "8.2",
      actividad  : "TIMELINE.ETAPA2.SECCION19.actividad",
      entregable: "Plan de capacitación, flujo de proceso.",
    },{
      requisito: "8.3 8.4 8.5",
      actividad:"TIMELINE.ETAPA2.SECCION20.actividad",
      entregable:"Flujo de proceso.",
    }


  ]



  obtieneCertificarActual(){

    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            console.log('productoID',localStorage.getItem('productoID'));
            console.log('fechaNorma',localStorage.getItem('FechaNorma'));
            if (fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')) {
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;
              this.fechaCertificar=this.productoCertificar.fechaNorma35;
              this.getAllTask(this.fechaCertificar);
                 // CENTROS DE TRABAJO HIJOS
                 this.info=this.colaboradoresService.getinfo();
               // FIN CENTRO DE TRABAJO HIJO
              throw BreakException;
            }
          }
          });
      } catch (e) {
        if (e !== BreakException) throw e;
      };
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }




  private getAllTask (fecha){
    this.data = {
      fechaDocumentador: fecha
    }
    var fechaTask;
    this.idiomasService.geTodoList(this.data).subscribe( (data : any)=>{
        this.arrayTodoList = data.secciones;
        this.colaboradoresService.getColaboradoresFast(this.productoCertificar.fechaNorma35, this.productoCertificar.idNorma35)
        .subscribe( (getFast: colabInter.getBDFast) => {
          this.info=this.colaboradoresService.getinfo();
          if(this.info.level==6){
            this.colaboradoresService.getColaboradores(this.productoCertificar.fechaNorma35,this.info.empresaPadre,this.productoCertificar.idNorma35)
            .subscribe( (response) => {
              this.info.totalColaboradores;
              if(this.info.totalColaboradores>0){
                if(this.info.totalColaboradores>50){
                  // El index 1 es encuesta de 16 a 50
                  this.arrayTodoList.splice(1,1);
                }else{
                  //El index 2 es el de más de 50
                  this.arrayTodoList.splice(2,1);
                }
                for(var i=0; i < this.arrayTodoList.length; i++){
                  this.getSeccion(this.arrayTodoList[i].nombreSeccion,i);
                   for(var k=0; k < this.arrayTodoList[i].tareas.length; k++){
                    this.cantidadTareas++;
                    fechaTask=this.arrayTodoList[i].tareas[k].fechaCreacion.toString();
                    this.arrayTodoList[i].tareas[k].fechaCreacion=fechaTask.substr(2,8);
                    if(this.arrayTodoList[i].tareas[k].estatus != ""){
                      this.tareasFinalizadas++;
                    }
                   }
                }
                this.porcentaje = (this.tareasFinalizadas * 100) / this.cantidadTareas;
              }
            });
          }

          if(getFast.message == 'Success' && getFast.numeroColaboradores > 0){
            if(getFast.numeroColaboradores>50){
              // El index 1 es encuesta de 16 a 50
              this.arrayTodoList.splice(1,1);
            }else{
              //El index 2 es el de más de 50
              this.arrayTodoList.splice(2,1);
            }
            for(var i=0; i < this.arrayTodoList.length; i++){
              this.getSeccion(this.arrayTodoList[i].nombreSeccion,i);
               for(var k=0; k < this.arrayTodoList[i].tareas.length; k++){
                fechaTask=this.arrayTodoList[i].tareas[k].fechaCreacion.toString();
                this.arrayTodoList[i].tareas[k].fechaCreacion=fechaTask.substr(2,8);
                this.cantidadTareas++;
                if(this.arrayTodoList[i].tareas[k].estatus != ""){
                  this.tareasFinalizadas++;
                }
               }
            }
            this.porcentaje = (this.tareasFinalizadas * 100) / this.cantidadTareas;

          }
        });
    });
  }

  private getSeccion (nombreseccion,pos){
    let pathTmp:any;
    switch(nombreseccion) {
      case "5.2 Identificar y analizar los factores de riesgo psicosocial": {
        pathTmp ="Política de prevención de riesgos psicosociales";
        this.ArrayPath[pos]="/NOM35/wizard/politica";
        this.ArraySecciones[pos]="WIZARD.PATRON.0.SECCION";
        this.ArrayNum[pos]="5.1";
        break;
      }
      case "5.3 Identificar y analizar los factores de riesgo psicosocial": {
        pathTmp = "Encuesta 16-50 colaboradores";
        this.ArrayPath[pos]="/NOM35/wizard/encuesta-16-50";
        this.ArraySecciones[pos]="WIZARD.PATRON.1.SECCION";
        this.ArrayNum[pos]="5.2, 7.1a); 7.2; 7.4; 7.5; 7.6; 7.7; 7.8 y 7.9";
        break;
      }
      case "5.4 Adoptar las medidas para prevenir y controlar los factores de riesgo psicosocial":{
        pathTmp ="Encuesta más 50 colaboradores";
        this.ArrayPath[pos]="/NOM35/wizard/encuesta-50-mas";
        this.ArraySecciones[pos]="WIZARD.PATRON.2.SECCION";
        this.ArrayNum[pos]="5.3, 7.1b, 7.2; 7.3; 7.4; 7.5; 7.6; 7.7; 7.8 y 7.9";
        break;
      }
      case "5.5 Identificar a los trabajadores que fueron sujetos a acontecimientos traumáticos severos":{
        pathTmp ="Medidas de prevención y control";
        this.ArrayPath[pos]="/NOM35/wizard/medidas-preventivas&control ";
        this.ArraySecciones[pos]="Medidas de prevención y control";
        this.ArrayNum[pos]="5.4; 8.1; 8.2; 8.3; 8.4 y 8.5";
        break;
      }
      case "5.6 Practicar exámenes médicos y evaluaciones psicológicas":{
        pathTmp ="Canal de quejas y denuncias";
        this.ArrayPath[pos]="/NOM35/wizard/quejas-denuncias";
        this.ArraySecciones[pos]="WIZARD.PATRON.3.SECCION";
        this.ArrayNum[pos]="8.1";
        break;
      }
      case "5.1 a) La prevención de los factores de riesgo psicosocial":{
        pathTmp ="Acciones y programas preventivos";
        this.ArrayPath[pos]="/NOM35/wizard/plan-acciones";
        this.ArraySecciones[pos]="WIZARD.PATRON.4.SECCION";
        this.ArrayNum[pos]="8.1, 8.2";
        break;
      }
      case "5.1 b) La prevención de la violencia laboral":{
        pathTmp ="Programa de intervención con evaluaciones y medidas de control";
        this.ArrayPath[pos]="/NOM35/wizard/kpis";
        this.ArraySecciones[pos]="WIZARD.PATRON.5.SECCION";
        this.ArrayNum[pos]="8.3, 8.4, 8.5";
        break;
      }
      case "5.1 c) La promoción de un entorno organizacional favorable":{
        pathTmp ="Encuesta acontecimientos traumáticos severos";
        this.ArrayPath[pos]="/NOM35/wizard/encuesta-eventos-traumáticos";
        this.ArraySecciones[pos]="WIZARD.PATRON.6.SECCION";
        this.ArrayNum[pos]="5.5";
        break;
      }
      case "5.7 a) La política de prevención de riesgos psicosociales":{
        pathTmp="Exámenes médicos y evaluaciones psicológicas";
        this.ArrayPath[pos]="/NOM35/wizard/exámenes-médicos";
        this.ArraySecciones[pos]="WIZARD.PATRON.7.SECCION";
        this.ArrayNum[pos]="5.6";
        break;
      }
      case "5.7 b) Las medidas adoptadas para combatir las prácticas opuestas":{
        pathTmp ="Difusión y promoción de información";
        this.ArrayPath[pos]="/NOM35/wizard/alteraciones-salud";
        this.ArraySecciones[pos]="WIZARD.PATRON.8.SECCION";
        this.ArrayNum[pos]="5.7";
        break;
      }
      case "5.7 c) Las medidas y acciones de prevención y, en su caso, las acciones ...":{
        pathTmp ="Registros";
        this.ArrayPath[pos]="/NOM35/wizard/registros";
        this.ArraySecciones[pos]="WIZARD.PATRON.9.SECCION";
        this.ArrayNum[pos]="5.8";
        break;
      }

   }


  }





}
